import React from "react";
import { Box, Table, TableBody, useTheme } from "@mui/material";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { StyledTableCell, StyledTableRow } from "../styled_components";

interface TableLoaderProps {
  tableCount?: number;
  rowCount?: number;
  columnCount?: number;
  removeHeader?: boolean;
}

const TableLoader: React.FC<TableLoaderProps> = ({
  tableCount = 2,
  rowCount = 5,
  columnCount = 6,
  removeHeader = false,
}) => {
  const theme = useTheme();

  const baseColor =
    theme.palette.mode === "dark" ? "#2c2c2c" : "#e0e0e0";
  const highlightColor =
    theme.palette.mode === "dark" ? "#3c3c3c" : "#f5f5f5";

  return (
    <Box sx={removeHeader ? { mt: 0 } : {}}>
      {Array.from({ length: tableCount }).map((_, tableIndex) => (
        <Box key={tableIndex} className="search-table">
          {!removeHeader && (
            <Box className="table-header" sx={{ height: "30px" }} />
          )}
          <Table>
            <TableBody>
              {Array.from({ length: rowCount }).map((_, rowIndex) => (
                <StyledTableRow key={rowIndex}>
                  {Array.from({ length: columnCount }).map((_, colIndex) => (
                    <StyledTableCell key={colIndex}>
                      <Skeleton
                        width="50%"
                        height={20}
                        baseColor={baseColor}
                        highlightColor={highlightColor}
                      />
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      ))}
    </Box>
  );
};

export default TableLoader;
